var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoPlaceHolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 96,
    viewBox: "0 0 118 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107 0H11C5.66671 0 0.333374 5.33333 0.333374 10.6667V85.3333C0.333374 91.2 5.13337 96 11 96H107C112.333 96 117.667 90.6667 117.667 85.3333V10.6667C117.667 5.33333 112.333 0 107 0ZM107 84.9067C106.926 85.0182 106.799 85.1298 106.694 85.2233C106.648 85.2639 106.606 85.301 106.573 85.3333H11V11.0933L11.4267 10.6667H106.52C106.632 10.741 106.743 10.8673 106.837 10.973C106.877 11.019 106.914 11.061 106.947 11.0933V84.9067H107ZM40.3334 50.6667L53.6667 66.72L72.3334 42.6667L96.3334 74.6667H21.6667L40.3334 50.6667Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlaceHolder);
export default __webpack_public_path__ + "static/media/PhotoPlaceHolder.8f552761484c46ba4aa707d04d6e3542.svg";
export { ForwardRef as ReactComponent };